import { ReactComponent as Icon } from '@basqet-dashboard/common/assets/icons/kyc-modal-icon.svg';
import { Button, Modal } from '@basqet-dashboard/common/components';
import { useUserContext } from '@basqet-dashboard/common/context';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { useNavigateTo } from '../../utils';

const KycModal = () => {
  const { user } = useUserContext();

  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsOpenModal(!window.localStorage.getItem('seenKycModal') && !isKycVerified);
    }, 3000);
  }, []);

  const { isKycVerified } = user;

  const closeModal = () => {
    setIsOpenModal(false);
    window.localStorage.setItem('seenKycModal', 'true');
  };

  const { navigateTo } = useNavigateTo();

  const getStarted = () => {
    closeModal();
    navigateTo('settings/kyc');
  };

  return (
    isOpenModal && (
      <Modal
        Icon={Icon}
        onModalClose={closeModal}
        header={{ name: 'Start account', cursive: 'Verification' }}>
        <p className="modal__text">
          To get started with basqet, we require some important information to access your identity
        </p>
        <Button isFull onClick={getStarted}>
          Get Started
        </Button>
      </Modal>
    )
  );
};

KycModal.propTypes = {
  onModalClose: PropTypes.func
};

export { KycModal };
